/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiResolveReviewRequest,
    InternalApiResolveReviewRequestFromJSON,
    InternalApiResolveReviewRequestToJSON,
    InternalApiReviewRequest,
    InternalApiReviewRequestFromJSON,
    InternalApiReviewRequestToJSON,
    InternalApiReviewRequestEntityType,
    InternalApiReviewRequestEntityTypeFromJSON,
    InternalApiReviewRequestEntityTypeToJSON,
} from '../models';

export interface FindByEntityTypeAndEntityIdRequest {
    entityType: InternalApiReviewRequestEntityType;
    entityId: string;
}

export interface GetListRequest {
    entityIds: Array<string>;
    entityType?: InternalApiReviewRequestEntityType;
}

export interface ResolveRequest {
    internalApiResolveReviewRequest: InternalApiResolveReviewRequest;
}

/**
 * 
 */
export class ReviewRequestsApi extends runtime.BaseAPI {

    /**
     * Get a review request by entity type and id, if present
     */
    async findByEntityTypeAndEntityIdRaw(requestParameters: FindByEntityTypeAndEntityIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiReviewRequest>> {
        if (requestParameters.entityType === null || requestParameters.entityType === undefined) {
            throw new runtime.RequiredError('entityType','Required parameter requestParameters.entityType was null or undefined when calling findByEntityTypeAndEntityId.');
        }

        if (requestParameters.entityId === null || requestParameters.entityId === undefined) {
            throw new runtime.RequiredError('entityId','Required parameter requestParameters.entityId was null or undefined when calling findByEntityTypeAndEntityId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/review-requests/{entityType}/{entityId}`.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters.entityType))).replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters.entityId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiReviewRequestFromJSON(jsonValue));
    }

    /**
     * Get a review request by entity type and id, if present
     */
    async findByEntityTypeAndEntityId(requestParameters: FindByEntityTypeAndEntityIdRequest, initOverrides?: RequestInit): Promise<InternalApiReviewRequest> {
        const response = await this.findByEntityTypeAndEntityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of active review requests
     */
    async getListRaw(requestParameters: GetListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiReviewRequest>>> {
        if (requestParameters.entityIds === null || requestParameters.entityIds === undefined) {
            throw new runtime.RequiredError('entityIds','Required parameter requestParameters.entityIds was null or undefined when calling getList.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        if (requestParameters.entityIds) {
            queryParameters['entityIds'] = requestParameters.entityIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/review-requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiReviewRequestFromJSON));
    }

    /**
     * Get a list of active review requests
     */
    async getList(requestParameters: GetListRequest, initOverrides?: RequestInit): Promise<Array<InternalApiReviewRequest>> {
        const response = await this.getListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve a review request
     */
    async resolveRaw(requestParameters: ResolveRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiResolveReviewRequest === null || requestParameters.internalApiResolveReviewRequest === undefined) {
            throw new runtime.RequiredError('internalApiResolveReviewRequest','Required parameter requestParameters.internalApiResolveReviewRequest was null or undefined when calling resolve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/review-requests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiResolveReviewRequestToJSON(requestParameters.internalApiResolveReviewRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resolve a review request
     */
    async resolve(requestParameters: ResolveRequest, initOverrides?: RequestInit): Promise<void> {
        await this.resolveRaw(requestParameters, initOverrides);
    }

}
